import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect, CustomFormControl } from '../../../../StyledComponents';

export const Schema = Yup.object().shape({
    becomingAwareThrough: Yup.string().required("Angabe ist erforderlich"),
    becomingAwareThroughOther: Yup.string()
        .when('becomingAwareThrough', {
            is: 'Sonstiges',
            then: Yup.string().required("Angabe ist erforderlich"),
        }),
    becomingAwareThroughEmployee: Yup.string()
        .when('becomingAwareThrough', {
            is: 'Mitarbeitende werben Mitarbeitende',
            then: Yup.string().required("Angabe ist erforderlich"),
        }),
    applicationLink: Yup.string(),
});



export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings  } = props;
    return (
        <>
            <Row className="mb-3">
                {values.becomingAwareThrough !== "Sonstiges" && values.becomingAwareThrough !== "Mitarbeitende werben Mitarbeitende" && <Form.Group className="mb-3" as={Col} controlId="formBecomingAwareThrough">
                    <Form.Label>Wie wurden Sie auf die Stelle aufmerksam?*</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="becomingAwareThrough"
                        value={values.becomingAwareThrough}
                        isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                        isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Dropdown-Auswahlmenü:</option>
                        {Options.BecomingAwareThroughLeader.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThrough}
                    </Form.Control.Feedback>
                </Form.Group>}
                {(values.becomingAwareThrough === "Sonstiges" || values.becomingAwareThrough ==="Mitarbeitende werben Mitarbeitende") && <Form.Group className="mb-2" as={Col} controlId="formBecomingAwareThrough">
                    <Form.Label>Wie wurden Sie auf die Stelle aufmerksam?</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="becomingAwareThrough"
                        value={values.becomingAwareThrough}
                        isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                        isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Dropdown-Auswahlmenü:</option>
                        {Options.BecomingAwareThroughLeader.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThrough}
                    </Form.Control.Feedback>
                </Form.Group>}
                {values.becomingAwareThrough === "Sonstiges" && <Form.Group className="mb-3" controlId="formBecomingAwareThroughOther">
                    <CustomFormControl
                        colors={colors}
                        placeholder="Bitte eingeben, wie Sie auf die Stelle aufmerksam geworden sind"
                        type="text"
                        name="becomingAwareThroughOther"
                        value={values.becomingAwareThroughOther}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.becomingAwareThroughOther && !errors.becomingAwareThroughOther}
                        isInvalid={touched.becomingAwareThroughOther && errors.becomingAwareThroughOther}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThroughOther}
                    </Form.Control.Feedback>
                </Form.Group>}
                {values.becomingAwareThrough === "Mitarbeitende werben Mitarbeitende" && <Form.Group className="mb-3" controlId="formBecomingAwareThroughEmployee">
                    <CustomFormControl
                        colors={colors}
                        placeholder="Bitte benennen Sie den Namen des/der Angestellten der BBBank"
                        type="text"
                        name="becomingAwareThroughEmployee"
                        value={values.becomingAwareThroughEmployee}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.becomingAwareThroughEmployee && !errors.becomingAwareThroughEmployee}
                        isInvalid={touched.becomingAwareThroughEmployee && errors.becomingAwareThroughEmployee}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThroughEmployee}
                    </Form.Control.Feedback>
                </Form.Group>}
            </Row>
        </>
    );
};